module.exports = __webpack_public_path__ + "img/PilotTrainingNew.9e44c936.png";